"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueContainer = void 0;
var _reactSelect = require("react-select");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ValueContainer = (0, _styledComponents.default)(_reactSelect.components.ValueContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 40px;\n  font-weight: 500;\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n  background-image: none;\n  padding: 0.375rem 16px !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.radius.sm;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondaryShade;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.tertiaryShade + 40;
});
exports.ValueContainer = ValueContainer;